function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconTransportationBusRexOutline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6 7V6c0-1.103.897-2 2-2h16c1.103 0 2 .897 2 2v1H6zm0 8h20V9H6v6zm0 9h20v-7H6v7zM24 2H8a4 4 0 00-4 4v18a2 2 0 002 2v2a2 2 0 002 2h1a2 2 0 002-2v-2h10v2a2 2 0 002 2h1a2 2 0 002-2v-2a2 2 0 002-2V6a4 4 0 00-4-4z",
    fill: props.color
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.5 22a1.5 1.5 0 10-.001-3.001A1.5 1.5 0 009.5 22zM22.5 22a1.5 1.5 0 10-.001-3.001A1.5 1.5 0 0022.5 22z",
    fill: props.color
  }));
}

export default SvgIconTransportationBusRexOutline;